//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";

export default {
    name: "SmartContractVarDeclaration",
    components: {
        AQInput,
        AQDropdown,
        AQCheckbox
    },
    props: {
        value: Object,
        defaultValue: { type: String, default: "" }
    },
    data() {
        return {

        };
    },
    computed: {
        ...mapGetters("diagrams", ["modelForProcessDefinition"]),
        ...mapGetters("smartContractDesigner", ["getterScTypes", "getCurrentContractData"]),

        getVariableTypeDDL() {
            const ddlType = [];
            if (this.getterScTypes && this.getCurrentContractData) {
                const dataTypes = this.getterScTypes.find(type => this.getCurrentContractData.bcType.id === type.id);
                dataTypes.bcDataTypeList.forEach(type => {
                    ddlType.push({
                        value: type.id,
                        data: type,
                        label: type.name

                    });
                });
                if (this.getCurrentContractData.bcType.type === "BC_HLF") {
                    const data = this.dataModel();
                    if (data && data.length) {
                        data.forEach(element => {
                            ddlType.push({
                                value: element.name,
                                label: element.name,
                                data: {
                                    active: null,
                                    canBeArray: null,
                                    id: null,
                                    modelDataType: element.name,
                                    name: null,
                                    type: element.name
                                }
                            });
                        });
                    }
                }
            }
            return ddlType;
        }
    },

    mounted() {
        if (!this.getCurrentContractData) {
            this.getCurrentContract();
        }
        const checkDataModel = this.dataModel();
        if (checkDataModel && !checkDataModel.length) {
            this.getModelForProcessDefinition();
        }
    },

    methods: {
        ...mapActions("smartContractDesigner", ["getScTypes", "getCurrentContract"]),
        ...mapActions("diagrams", ["getModelForProcessDefinition"]),

        dataModel() {
            return this.modelForProcessDefinition({ withProps: { isBCReady: true } });
        }
    }
};
